module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"q1":"May I cancel subscription whenever I feel like?"},"zhHant":{"q1":"我不想繼續使用時，隨時可以取消訂閱嗎？"},"ja":{"q1":"Xロボットモンはいつでも解約できますか？"},"ko":{"q1":"내가 더 이상 사용하고 싶지 않을 때 언제든지 구독을 취소할 수 있습니까?"}}')
  delete Component.options._Ctor
}
